const {
  monitorsLog,
  getApolloPlugins,
  getAvailableMonitors
} = require('@blaze-cms/core-monitors/src/utils');
const {
  env: { isEnvTrue }
} = require('@blaze-cms/utils');
const serverMonitors = require('./server-monitors');

const { PLUGIN_NAME } = require('./constants');
const { version } = require('../package.json');

async function load(app, options = {}) {
  if (!isEnvTrue('BLAZE_DISABLE_MONITOR_LISTENERS')) {
    app.events.on('monitor:log', data => monitorsLog(data));
    process.on('uncaughtExceptionMonitor', err => monitorsLog({ error: err }));
  }

  addListenersForApolloServer(app);

  return {
    name: PLUGIN_NAME,
    version,
    serverMonitors
  };
}

function addListenersForApolloServer(app) {
  const monitors = getAvailableMonitors();
  if (!monitors.length) return;

  app.events.once('plugin:graphql:apollo-settings:load', addApolloSettings => {
    const monitorPlugins = getApolloPlugins(app);
    addApolloSettings('monitor', {
      settings: {
        plugins: [...monitorPlugins]
      }
    });
  });
}

load.pluginName = PLUGIN_NAME;

module.exports = load;
